module.exports = __webpack_public_path__ + "static/degrant-mfw26-4c1fe4f55bc8d5a9f1f3c4b65be0d655.jpg";